import cn from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
var Email = function Email(_ref) {
  var offsetKey = _ref.offsetKey,
    decoratedText = _ref.decoratedText,
    isDark = _ref.isDark;
  return /*#__PURE__*/_jsx("a", {
    "data-offset-key": offsetKey,
    className: cn('break-all truncate', isDark ? 'link-level4-dark' : 'link-level4'),
    href: "mailto:".concat(decoratedText),
    target: "_blank",
    rel: "noopener noreferrer",
    children: decoratedText
  });
};
export default Email;